import { useMemo } from "react";
import { useSelector } from "react-redux";
import { assetSelectors } from "../ducks/asset";
import { isWithinMaintenancePeriod } from "../utils/date";
import { LocalStorageManager } from "../core/storage/LocalStorageManager";
import { AppConfig } from "../AppConfig";

export const useMaintenance = () => {
  const maintenanceInfo = useSelector(assetSelectors.maintenanceInfo);

  const isIgnoreMaintenance = LocalStorageManager.Instance.getObject(
    AppConfig.Instance.LocalStorageKey["isIgnoreMaintenance"],
  );

  const isAppMaintenance = useMemo(() => {
    if (!maintenanceInfo || !maintenanceInfo.is_maintenance) {
      return false;
    }

    return (
      isIgnoreMaintenance !== true &&
      isWithinMaintenancePeriod(
        maintenanceInfo.app_start_date,
        maintenanceInfo.app_end_date,
      )
    );
  }, [maintenanceInfo]);

  const isPaymentMaintenance = useMemo(() => {
    if (!maintenanceInfo || isIgnoreMaintenance) {
      return false;
    }
    return isWithinMaintenancePeriod(
      maintenanceInfo.payment_start_date,
      maintenanceInfo.payment_end_date,
    );
  }, [maintenanceInfo]);

  return {
    maintenanceInfo,
    isAppMaintenance,
    isPaymentMaintenance,
  };
};
